import { useLazyQuery as _useLazyQuery, useQuery as _useQuery } from "@apollo/client";
export {
  ApolloProvider,
  ApolloLink,
  gql,
  useMutation,
  useApolloClient,
  HttpLink,
  NetworkStatus,
  ApolloError,
} from "@apollo/client";
export type {
  ApolloQueryResult,
  FetchResult,
  WatchQueryFetchPolicy,
  DocumentNode,
} from "@apollo/client";
export {
  getApolloAuthLink,
  getClient,
  getUnauthLink,
  setApolloAuthLinkWithConfig,
} from "@stadium/services/apollo-client/utils/get-client";
export { setContext } from "@apollo/client/link/context";

export { useAuthQuery } from "@stadium/services/apollo-client/utils/hooks";

export const useLazyQuery: typeof _useLazyQuery = (...args) =>
  _useLazyQuery(args[0], { notifyOnNetworkStatusChange: true, ...args[1] });

export const useQuery: typeof _useQuery = (...args) =>
  _useQuery(args[0], { notifyOnNetworkStatusChange: true, ...args[1] });
